import { Component, ojs, app } from "modular-openscriptjs";
import { pc, uc, gc } from "../declarations";
import TopNav from "./TopNav";
import SideNav from "./SideNav";
import BottomNav from "./BottomNav";
import Footer from "./Footer";
import MainContent from "./Blocks/MainContent";

const h = app("h");

ojs(TopNav, SideNav, BottomNav, Footer, MainContent);

export default class Layout extends Component {
    modalDisplayed = false;

    render(authState, ...args) {
        return h.div(
            // {class: 'position-relative container-fluid'},
            h.TopNav(pc.headerItems, uc.permissions, uc.roles, authState),
            h.div(
                { class: "px-md-3 d-md-flex " },

                // Navigation is shown to everyone, guests included (App
                // Store 5.1.1) - account-only destinations prompt sign-in.
                h.SideNav(
                    pc.sideItems,
                    pc.sideNavCollapsed,
                    uc.permissions,
                    uc.roles,
                    authState,
                ),
                h.MainContent(authState, ...args),
            ),
            h.BottomNav(pc.bottomItems, uc.permissions, uc.roles, gc.auth),
            h.Footer(),
        );
    }
}
